 
import * as constants from './constants';
import userRequest, {
    userApi
} from 'common/request';
const changeCourseInfoList = (infoList) => ({
    type: constants.CHANGE_COURSELIVE_LIST_DATA,
    infoList 
});
export const changeCourseInfo = (info) => ({
    type: constants.CHANGE_COURSELIVE_DATA,
    info 
}); 
const changeTopicList = (topicList) => ({
    type: constants.CHANGE_TOPIC_LIST,
    topicList 
}); 
 
const changeTopicChatList = (topicChatList) => ({
    type: constants.CHANGE_TOPIC_CHAT_LIST,
    topicChatList 
});  
export const changeTopicId= (topicId) => ({
    type: constants.CHANGE_TOPIC_ID,
    topicId 
}); 
const changeAttachmentList = (attachmentList)=>({
    type:constants.CHANGE_ATTACHMENT_LIST,
    attachmentList
})
 
const changeCollect = (collect)=>({
    type:constants.CHANGE_COLLECT,
    collect
})
 export const getCourseInfo = (course_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.courseDetail, {
             course_id
         }).then((res) => {
             if (res.code === 0) {
                console.log(res.data)
                 dispatch(changeCourseInfoList(res.data))
                 dispatch(changeCourseInfo(res.data)) 
               
                 if (res.data.attachments) {
                     
                   let attachments ={}
                    try{
                      //在这里运行代码
                         attachments = JSON.parse(res.data.attachments);
                    }
                    catch(err){
                      //在这里处理错误
                        attachments ={}
                    }
                    dispatch(changeAttachmentList(attachments));
                   
                 } 
             }
         })
     }
 }
 export const getTopicLists = () => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.topicChat + userApi.getTopicLists).then((res) => {
            if(res.success===true&&res.result.err===0&&res.result.data.code===0){
                let result = res.result.data.data || ''
                dispatch(changeTopicList(result))
            }
              
         })
     }
 }
export const getCourseWatched=(course_id) =>{
    return (dispatch)=>{
        userRequest.get(window.AppConfig.mainIP+userApi.getCourseWatch+`${course_id}`).then((res)=>{})
    }
};
 export const getTopicChatLists = () => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.topicChat + userApi.getTopicChatLists).then((res) => {
            if(res.success===true&&res.result.err===0&&res.result.data.code===0){
                 let result = res.result.data.data || ''
                 dispatch(changeTopicChatList(result))
            }
              
         })
     }
 }
 // addTopicChat
 export const addTopicChat = (content,user_id,topic_id,user_name) => {
     return (dispatch) => {
         userRequest.post(window.AppConfig.topicChat + userApi.addTopicChat, {
             content,
             user_id,
             topic_id,
             user_name
         }).then((res) => {
            if(res.result&&res.result.data&&res.result.data.code===0&&res.result.data.data){
               dispatch(getTopicChatLists())
            }
           
         })
     }
 }
  
//查询是否收藏
  export const getRecord = (course_id,user_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.getRecord, {
             type:'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                  
                if(res.data.models&&res.data.models.length!==0){
                    dispatch(changeCollect(true))
                  }else{
                    dispatch(changeCollect(false))
                  }
 

             }
         })
     }
 }
 //添加收藏 addRecord
   export const addRecord = (course_id,user_id) => {
     return (dispatch) => {
         userRequest.post(window.AppConfig.mainIP + userApi.addRecord, {
             type:'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                dispatch(changeCollect(true))
             }
         })
     }
 }
//删除收藏 delRecord
   export const delRecord = (course_id,user_id) => {
     return (dispatch) => {
         userRequest.post(window.AppConfig.mainIP + userApi.delRecord, {
             type:'collect',
             course_id,
             user_id
         }).then((res) => {
             if (res.code === 0) {
                  
                dispatch(changeCollect(false))
             }
         })
     }
 }